import React from 'react';
import {
  Alert,
  Badge,
  Button,
  Card,
  Col,
  Form,
  Row,
  Spinner,
} from 'react-bootstrap';
import {
  FaSearch,
} from 'react-icons/fa';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import Select from 'react-select';
import Loading from '~/Components/Loading';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';

export default function RelatorioTab(props) {
  var filtrosRelatorio = props.filtrosRelatorio;
  var setFiltrosRelatorio = props.setFiltrosRelatorio;
  var empreendimentoOptions = props.empreendimentoOptions;
  var dadosRelatorio = props.dadosRelatorio;
  var isLoadingRelatorio = props.isLoadingRelatorio;
  var erroRelatorio = props.erroRelatorio;
  var onBuscar = props.onBuscar;
  var onDetalhar = props.onDetalhar;
  var formatarDataCurta = props.formatarDataCurta;

  return (
    <>
      <Card className="mt-3 shadow-sm">
        <Card.Header className="bg-white">
          <strong>Filtros do relatório</strong>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md={4}>
              <Form.Group>
                <Form.Label>Empreendimento</Form.Label>
                <Select
                  placeholder="Selecione..."
                  options={empreendimentoOptions}
                  value={filtrosRelatorio.codigoFamilia}
                  onChange={function (opt) {
                    setFiltrosRelatorio(function (prev) { return Object.assign({}, prev, { codigoFamilia: opt }); });
                  }}
                  styles={customStyles}
                  components={{ DropdownIndicator: DropdownIndicator }}
                  noOptionsMessage={function () { return 'Nenhuma opção'; }}
                  isClearable
                />
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group>
                <Form.Label>Quadra</Form.Label>
                <Form.Control
                  placeholder="Quadra"
                  value={filtrosRelatorio.mapa1}
                  onChange={function (e) {
                    var val = e.target.value;
                    setFiltrosRelatorio(function (prev) { return Object.assign({}, prev, { mapa1: val }); });
                  }}
                />
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group>
                <Form.Label>Lote</Form.Label>
                <Form.Control
                  placeholder="Lote"
                  value={filtrosRelatorio.mapa2}
                  onChange={function (e) {
                    var val = e.target.value;
                    setFiltrosRelatorio(function (prev) { return Object.assign({}, prev, { mapa2: val }); });
                  }}
                />
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group>
                <Form.Label>Cód. Corretor</Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Código"
                  value={filtrosRelatorio.codigoCorretor || ''}
                  onChange={function (e) {
                    var val = parseInt(e.target.value, 10) || 0;
                    setFiltrosRelatorio(function (prev) { return Object.assign({}, prev, { codigoCorretor: val }); });
                  }}
                />
              </Form.Group>
            </Col>
            <Col
              md={2}
              className="d-flex align-items-end justify-content-end"
            >
              <Button
                variant="primary"
                disabled={isLoadingRelatorio}
                onClick={onBuscar}
              >
                {isLoadingRelatorio ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      className="mr-1"
                    />
                    Buscando...
                  </>
                ) : (
                  <>
                    <FaSearch className="mr-1" />
                    Buscar
                  </>
                )}
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {erroRelatorio && (
        <Alert variant="danger" className="mt-3">
          {erroRelatorio}
        </Alert>
      )}

      {isLoadingRelatorio && (
        <div className="text-center my-4">
          <Loading />
        </div>
      )}

      {!isLoadingRelatorio && dadosRelatorio.length > 0 && (
        <Card className="mt-3 shadow-sm">
          <Card.Header className="bg-white">
            <strong>
              Ativos com fila{' '}
              <Badge variant="primary" className="ml-1">
                {dadosRelatorio.length}
              </Badge>
            </strong>
          </Card.Header>
          <Card.Body className="table-responsive p-0">
            <Table className="table table-striped table-bordered table-hover mb-0">
              <Thead>
                <Tr className="text-center">
                  <Th>Empreendimento</Th>
                  <Th>Quadra</Th>
                  <Th>Lote</Th>
                  <Th>Reservado para</Th>
                  <Th>Imobiliária</Th>
                  <Th>Reservado em</Th>
                  <Th>Válido até</Th>
                  <Th>Qtd Fila</Th>
                  <Th>Detalhar</Th>
                </Tr>
              </Thead>
              <Tbody className="text-center">
                {dadosRelatorio.map(function (ativo, idx) {
                  return (
                    <Tr key={'rel-' + ativo.codigo_ativo + '-' + idx}>
                      <Td className="text-left">
                        {ativo.empreendimento || '-'}
                      </Td>
                      <Td>{ativo.quadra || '-'}</Td>
                      <Td>{ativo.lote || '-'}</Td>
                      <Td>{ativo.corretor || '-'}</Td>
                      <Td>{ativo.imobiliaria || '-'}</Td>
                      <Td style={{ whiteSpace: 'nowrap' }}>
                        {formatarDataCurta(ativo.emissao)}
                      </Td>
                      <Td style={{ whiteSpace: 'nowrap' }}>
                        {formatarDataCurta(ativo.validade)}
                      </Td>
                      <Td>
                        <Badge
                          variant={ativo.fila > 0 ? 'warning' : 'secondary'}
                        >
                          {ativo.fila}
                        </Badge>
                      </Td>
                      <Td>
                        <Button
                          size="sm"
                          variant="info"
                          onClick={function () { onDetalhar(ativo); }}
                        >
                          <FaSearch />
                        </Button>
                      </Td>
                    </Tr>
                  );
                })}
              </Tbody>
            </Table>
          </Card.Body>
        </Card>
      )}

      {!isLoadingRelatorio &&
        dadosRelatorio.length === 0 &&
        erroRelatorio === null && (
          <Alert variant="info" className="mt-3">
            Informe os filtros acima e clique em Buscar para consultar os
            ativos.
          </Alert>
        )}
    </>
  );
}
